const awscognito = {
  Auth: {
    region: "us-west-2",
    // alpha
    // userPoolId: 'us-west-2_TIZRwcV7z',
		// userPoolWebClientId: '74dhn9ug4pgp7kjcsdu68i6s1g',

    //beta
    userPoolId: "us-west-2_3m786js8T",
    userPoolWebClientId: "3d1jh5c36r4ll2ftbq03argar9",
    authenticationFlowType: "CUSTOM_AUTH",

    // prod
    // userPoolId: "us-west-2_qbFsli3B8",
    // userPoolWebClientId: "46scrunedvfuhu8s5sn4dmehhf",
    // authenticationFlowType: "CUSTOM_AUTH",
  },
};

export default awscognito;
